import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
// import { composeWithDevTools } from "redux-devtools-extension";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import reducer from "../reducer/index";

const persistConfig = {
  key: "root",
  storage,
};

const persistorReducer = persistReducer(persistConfig, reducer);
export const store = createStore(
  persistorReducer,
  applyMiddleware(thunk)
  // composeWithDevTools()
);
export const persistor = persistStore(store);

export default (store, persistor);
